export default {
  title: 'Arviosi auttaa todella paljon ❤️',
  description: '{{name}} {{store}}-kaupassa — napauta vain tähteä',
  buttons: {
    not_now: 'Ei nyt',
    continue: 'Jatka',
  },
};
